<template>
  <div class="text-center">
    <v-dialog v-model="dialog" width="500">
      <template v-slot:activator="{ on, attrs }">
        <v-btn icon v-bind="attrs" v-on="on">
          <v-icon color="primary">mdi-fingerprint</v-icon></v-btn
        >
      </template>

      <v-card>
        <v-card-title class="text-h5 grey lighten-2">
          <v-icon color="primary">mdi-fingerprint</v-icon> Data privacy
        </v-card-title>
        <v-list three-line>
          <template v-for="(item, index) in links">
            <v-subheader
              v-if="item.header"
              :key="item.id"
              v-text="item.header"
            ></v-subheader>

            <v-divider
              v-else-if="item.divider"
              :key="index"
              :inset="item.inset"
            ></v-divider>

            <v-list-item
              v-else
              :key="item.title"
              :href="item.url"
              target="blank"
            >
              <v-list-item-avatar>
                <v-icon>{{ item.icon }}</v-icon>
              </v-list-item-avatar>

              <v-list-item-content>
                <v-list-item-title v-html="item.title"></v-list-item-title>
                <v-list-item-subtitle>
                  Last updated: {{ item.update_at }}</v-list-item-subtitle
                >
              </v-list-item-content>
            </v-list-item>
          </template>
        </v-list>

        <v-divider></v-divider>

        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn color="primary" text @click="dialog = false"> Colse </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </div>
</template>
<script>
export default {
  data() {
    return {
      dialog: false,
      links: [
        {
          id: 1,
          title: "Privacy policy",
          icon: "mdi-shield-account",
          url: "https://quickdeliverysystem.com/privacy/index.html",
          update_at: "November 02, 2024",
        },
        {
          id: 2,
          title: "Terms and Conditions",
          url: "https://quickdeliverysystem.com/terms-conditions/index.html",
          icon: "mdi-scale-balance",
          update_at: "November 02, 2024",
        },
        {
          id: 3,
          title: "Cookies",
          url: "https://quickdeliverysystem.com/cookie/index.html",
          icon: "mdi-cookie",
          update_at: "November 02, 2024",
        },
      ],
    };
  },
};
</script>
